import { keysToSnake } from '#/api/adapters/wireCase';
import { createPurchaseAmendmentApi } from '#/api/srm/createPurchaseAmendmentApi';

/** 物料採購異動單：body 已由 `buildPurchaseOrderAmendmentPayload` 組好（camel）。 */
const api = createPurchaseAmendmentApi('/srm/purchase-order', {
  serializeWrite: keysToSnake,
});

export const fetchPurchaseOrderAmendmentList = api.fetchList;
export const fetchPurchaseOrderAmendmentDetail = api.fetchDetail;
export const createPurchaseOrderAmendment = api.create;
export const updatePurchaseOrderAmendment = api.update;
export const deletePurchaseOrderAmendment = api.remove;
export const submitPurchaseOrderAmendment = api.submit;
export const rejectPurchaseOrderAmendment = api.reject;
export const approvePurchaseOrderAmendment = api.approve;
